var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "53px",
    viewBox: "0 0 76 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/video",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(0.000000, 1.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6819218,4.21735889 C70.8648085,4.21735889 70.034516,4.45458532 69.2832989,4.96857594 L54.8256655,13.9831806 L54.8256655,6.29967983 C54.8256655,2.82035875 51.7680803,0 47.9988158,0 L6.8268497,0 C3.05758519,0 0,2.82035875 0,6.29967983 L0,44.3086268 C0,47.7879479 3.05758519,50.6083066 6.8268497,50.6083066 L47.9988158,50.6083066 C51.7680803,50.6083066 54.8256655,47.7879479 54.8256655,44.3086268 L54.8256655,36.6251261 L69.2832989,45.6265514 C70.034516,46.1537213 70.8779878,46.3777685 71.6819218,46.3777685 C73.8696767,46.3777685 75.9124599,44.6644664 75.9124599,42.2263058 L75.9124599,8.36882154 C75.9124599,5.93066093 73.8696767,4.21735889 71.6819218,4.21735889 Z M48.4996272,17.9237753 L48.4996272,44.1372966 C48.4205517,44.1900136 48.2624007,44.2822683 47.9988158,44.2822683 L6.8268497,44.2822683 C6.56326477,44.2822683 6.40511381,44.2031928 6.32603833,44.1372966 L6.32603833,6.47101004 C6.40511381,6.41829305 6.56326477,6.32603833 6.8268497,6.32603833 L47.9988158,6.32603833 C48.2624007,6.32603833 48.4205517,6.40511381 48.4996272,6.47101004 L48.4996272,17.9237753 Z M69.5864216,38.3779659 L54.8256655,29.1788518 L54.8256655,21.4426341 L69.5864216,12.24352 L69.5864216,38.3779659 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.555db91f2a650d6d7b77883248a685f9.svg";
export { ForwardRef as ReactComponent };